import { ADD_ASSETS, AssetsPayload, DELETE_ASSET, UPDATE_ASSET, EDIT_ASSET, SAVE_ASSET,LOAD_ASSET, ADD_ASSET_LOOKUP, CANCEL_EDIT_ASSET } from "./types";
import * as _ from "lodash";
import { store } from "../..";
import { updateProps, updateFields } from '../formCreation/action'
import { logger } from "../../../constant/winston";
import { getAssetLookupTable } from "../../../helpers/commonFunction/getAssetLookupTable";

export function addAssets(data: any): AssetsPayload {
    return {
        type: ADD_ASSETS,
        data
    }
}

export function addAssetLookupTable(data: any): AssetsPayload {
  return {
      type: ADD_ASSET_LOOKUP,
      data
  }
}

export function deleteAsset(id: string): AssetsPayload {
    return {
        type: DELETE_ASSET,
        data: id
    }
}

export function editAsset(assetId: string) {
  return {
    type: EDIT_ASSET,
    data: assetId
  }
}

export function saveAsset() {
  return {
    type: SAVE_ASSET,
  }
}
export function cancelEditAsset() {
  return {
    type: CANCEL_EDIT_ASSET,
  }
}

export function loadAssets(data: any) {
  return {
    type: LOAD_ASSET,
    data,
  }
}

export function updateAssetProperties(data: any) {
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const { list } = reduxStore.assets;
    const { json: asset, ...others } = list[data.assetId];
    let assetLookupTable = {};
    getAssetLookupTable(list, assetLookupTable);
    try {
      const splits: any = data.id.split("#");
      let [updatedAsset]: any = await updateProps([asset], splits, data.data);
      dispatch({
        type: UPDATE_ASSET,
        data: {
          id: data.assetId,
          data: {
            ...others,
            json: updatedAsset,
          }
        },
      });
      dispatch(addAssetLookupTable(assetLookupTable));
    } catch (e) {
      logger.error("Error updating asset properties: ", e);
    }
  };

}

export const addAssetJson = (data: any) => {
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const assetId = reduxStore.assets.selectedAssetId;
    const { json: asset, ...others } = reduxStore.assets.list[assetId];

    const splits: any = data.data.id.split("#");
    const ids = _.reject(splits, splits.splice(-1, 1));
    const [updatedAsset]: any = await updateFields([asset], ids, data.data);

    dispatch({
      type: UPDATE_ASSET,
      data: {
        id: assetId,
        data: {
          ...others,
          json: updatedAsset,
        }
      },
    });
  };
}

async function addComponent(data: any, providedForm?: any) {
  let asset: any;

  if (!providedForm) {
    const reduxStore = _.cloneDeep(store.getState());
    const selectedAssetId = reduxStore.assets.selectedAssetId
    const { json } = reduxStore.assets.list[selectedAssetId];
    asset = [json];
  } else {
    asset = providedForm;
  }

  let dropAdded: any = [];
  let dropAddedJson: any = [];
  const droppedContainerSplits: any = data.droppedContainer.json.id.split("#");

  dropAdded = [...data.droppedContainer.json.fields];

  dropAdded.push({ ...data.draggedItem });

  const dropAddedData = {
    fields: dropAdded,
  };

  dropAddedJson = await updateProps(
    asset,
    droppedContainerSplits,
    dropAddedData,
    false
  );

  return dropAddedJson;
}

async function deleteComponent(data: any, providedForm?: any) {
  let asset: any;
  if (!providedForm) {
    const reduxStore = _.cloneDeep(store.getState());
    const selectedAssetId = reduxStore.assets.selectedAssetId
    const { json } = reduxStore.assets.list[selectedAssetId];
    asset = [json];
  } else {
    asset = providedForm;
  }

  let dragDeleted: any = [];
  let dragDeletedJson: any = [];
  const draggedItemContainerSplits: any =
    data.draggedItemContainer.id!.split("#");

  //Remove dragged item from its container
  dragDeleted = data.draggedItemContainer?.fields?.filter(
    (item: any) => item.id !== data.itemId
  );

  const dragDeletedData = {
    fields: dragDeleted,
  };

  dragDeletedJson = await updateProps(
    asset,
    draggedItemContainerSplits,
    dragDeletedData,
    false
  );
  return dragDeletedJson;
}

export function addRemoveOnDragCompleteAsset(
  dragDeleteData: any,
  dragAddData: any,
) {
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const assetId = reduxStore.assets.selectedAssetId;
    const asset = reduxStore.assets.list[assetId];
    delete asset.json

    let bufferForm: any;
    let finalForm: any;
    if (dragDeleteData.draggedItemContainer.id.startsWith(dragAddData.droppedContainer.json.id)) {
      bufferForm = await addComponent(dragAddData);
      finalForm = await deleteComponent(dragDeleteData, bufferForm);
    } else {
      bufferForm = await deleteComponent(dragDeleteData);
      finalForm = await addComponent(dragAddData, bufferForm);
    }

    dispatch({
      type: UPDATE_ASSET,
      data: {
        id: assetId,
        data: {
          ...asset,
          json: finalForm[0],
        }
      },
    });
  };
}


export function removeComponentFromAsset(data: any) {
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const asset = reduxStore.assets.list[data.assetId];
    delete asset.json

    let [updatedAsset] = await deleteComponent(data);
    dispatch({
      type: UPDATE_ASSET,
      data: {
        id: data.assetId,
        data: {
          ...asset,
          json: updatedAsset,
        }
      },
    });
  };
}

export function sortAssetsOnDrag(data: any) {
  const { assetId, draggedItem, container, addIndex } = data;
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const { json: asset, ...others } = reduxStore.assets.list[assetId];
    const draggedItemContainerSplits: any = container.id!.split("#");

    const removedDraggedItem = container.fields.filter(
      (item: any) => item.id !== draggedItem.id
    );
    removedDraggedItem.splice(addIndex, 0, draggedItem);
    const [updatedAsset]: any = await updateProps(
      [asset],
      draggedItemContainerSplits,
      { fields: removedDraggedItem },
      false
    );

    dispatch({
      type: UPDATE_ASSET,
      data: {
        id: assetId,
        data: {
          ...others,
          json: updatedAsset,
        }
      },
    });
  };
}
